<template>
    <div ref="container" style='width: 100%' class="container d-flex flex-column h-100">
        <loading ref="loading"></loading>

        <header class="text-center">
            <div class="header-icon header-icon--login"></div>
            <!-- <img src="/img/egl/lock-standard3.svg" alt="" class="header-icon"> -->
            <h1 class="h2">{{ $t('translations.secure_your_account')}}</h1>
            <!-- <p>Enter the email address that you registered with, then check your email for a reset link</p> -->
        </header>

        <div class="card-default container mx-auto">
            <local-error v-bind:inline='["password"]'></local-error>

            <password v-bind:errors='errors' v-bind:email='auth.email' v-bind:passwordfield.sync='auth.password'></password>
            <div class="">
                <button v-on:click.prevent='resetPassword()' class="btn btn-primary btn-block btn-round mt-2">
                    {{ $t('translations.reset_password')}}
                </button>
            </div>
        </div>
        
        <div v-if='tBrandSetting("conf_show_licence_agreement")' class="mt-auto w-100 p-2">
            <p class="text-center"><strong><a target="_blank" href="https://askmygp.uk/about-us/askmygp-end-user-licence-agreement-eula/">{{ $t('translations.terms_of_use') }}</a></strong></p>
        </div>
        <div v-else class="pb-5"></div>
        
    </div><!--ref:container-->
</template>

<script>

export default {
    props: [
        'returnpath',
    ],
    data: function(){
        return {
            auth: {
                token: "",
                email: "",
                password: "",
            },
            dob: null,
            errors: [],
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.setLoading(true);
            
            axios.get(`/api/vp1/auth/getCampaignUser/${this.$route.params.campaign_id}/${this.$route.params.user_id}/${this.$route.params.token}`)
            .then((res) => {
                if(res.data && !res.data.user) {
                    
                    if(this.is_logged_in() && this.$root.user.id == this.$route.params.user_id) {
                        this.setLoading(false);
                        app.$root.$router.push({path: `/campaign/${this.$route.params.campaign_id}/${this.$route.params.user_id}`});
                    }
                    else {
                        window.api_token = null;
                        this.$root.api_token = window.api_token;

                        if(window.Echo) {
                            delete window.Echo.connector.options.auth.headers['Authorization'];
                            delete axios.defaults.headers.common['Authorization'];
                        }

                        axios.get('/logout')
                        .finally(() => {
                            this.setLoading(false);
                            app.$root.$router.push({path: "/login/" + encodeURIComponent(`/campaign/${this.$route.params.campaign_id}/${this.$route.params.user_id}`)});
                        });
                    }
                }
                else {
                    this.auth.email = res.data.user.email;
                    
                    window.api_token = null;
                    this.$root.api_token = window.api_token;

                    if(window.Echo) {
                        delete window.Echo.connector.options.auth.headers['Authorization'];
                        delete axios.defaults.headers.common['Authorization'];
                    }
                    
                    axios.get('/logout')
                    .finally(() => {
                        this.setLoading(false);
                    });
                }
            }).catch((error) => {
                this.setLoading(false);
                this.$router.push({path: "/profile"});
            });
        },
        resetPassword() {
            this.auth.token = this.$route.params.token;
            this.setLoading(true);
            
            axios.post('/api/vp1/auth/setNewAccountPassword', this.auth).then((res) => {
                this.setLoading(false);
                this.addNotification({type: "success", content: this.$t('translations.password_reset_successfully') });
                
                axios.post('/ajaxlogin', this.auth).then((res) => {

                    //this.addNotification({type: "success", content: 'Logged in successfully'});

                    window.api_token = res.data.api_token;
                    this.$root.api_token = window.api_token;

                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token;

                    return this.$root.loadCore(true, {path: `/campaign/${this.$route.params.campaign_id}/${this.$route.params.user_id}`});
                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "create");
                });

            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "reset");
            });
        },
        
    }
}
</script>
